const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.startOutputBuffer();
                this.echo(`c-media-link
  `);
                this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                context.proxy[`_class`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.startOutputBuffer();
                this.echo(`c-media-link__content
  `);
                this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, (context.has(`content_class`) ? context.get(`content_class`) : null), `html`, null, true]));
                context.proxy[`_content_class`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.startOutputBuffer();
                this.echo(`c-media-link__icon
  `);
                this.echo(this.env.getFilter('escape').traceableCallable(18, this.source)(...[this.env, (context.has(`icon_class`) ? context.get(`icon_class`) : null), `html`, null, true]));
                context.proxy[`_icon_class`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.startOutputBuffer();
                this.traceableDisplayBlock(27, this.source)('object', context.clone(), blocks);
                context.proxy[`_object`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.startOutputBuffer();
                this.traceableDisplayBlock(44, this.source)('content', context.clone(), blocks);
                context.proxy[`_content`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
`);
                this.echo(this.include(context, this.source, this.loadTemplate(`47db05cf10de4356e3b2ef78415e3bec3029bc617aa2ade01eb5c25e57bb5961`, `47db05cf10de4356e3b2ef78415e3bec3029bc617aa2ade01eb5c25e57bb5961`, 53, 68), new Map([[`class`, (context.has(`_class`) ? context.get(`_class`) : null)], [`content_class`, (context.has(`_content_class`) ? context.get(`_content_class`) : null)]]), true, false, 53));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                if ((context.has(`avatar`) ? context.get(`avatar`) : null)) {
                    this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, (context.has(`avatar`) ? context.get(`avatar`) : null)], [`alt`, (context.has(`avatar_alt`) ? context.get(`avatar_alt`) : null)], [`width`, (context.has(`avatar_width`) ? context.get(`avatar_width`) : null)], [`height`, (context.has(`avatar_height`) ? context.get(`avatar_height`) : null)], [`srcset`, (context.has(`avatar_srcset`) ? context.get(`avatar_srcset`) : null)], [`sizes`, (context.has(`avatar_sizes`) ? context.get(`avatar_sizes`) : null)], [`size`, (context.has(`avatar_size`) ? context.get(`avatar_size`) : null)], [`shape`, (context.has(`avatar_shape`) ? context.get(`avatar_shape`) : null)]]), false, false, 29));
                }
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.env.getFilter('escape').traceableCallable(44, this.source)(...[this.env, (context.has(`label`) ? context.get(`label`) : null), `html`, null, true]));
            }

            getTemplateName() {
                return `47db05cf10de4356e3b2ef78415e3bec3029bc617aa2ade01eb5c25e57bb5961`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `47db05cf10de4356e3b2ef78415e3bec3029bc617aa2ade01eb5c25e57bb5961`, ``);
            }
        }],
        [68, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `47db05cf10de4356e3b2ef78415e3bec3029bc617aa2ade01eb5c25e57bb5961`, 53);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.env.getFilter('escape').traceableCallable(57, this.source)(...[this.env, (context.has(`_object`) ? context.get(`_object`) : null), `html`, null, true]));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <a class="c-media-link__action `);
                this.echo(this.env.getFilter('escape').traceableCallable(59, this.source)(...[this.env, (context.has(`action_class`) ? context.get(`action_class`) : null), `html`, null, true]));
                this.echo(`"
      href="`);
                this.echo(this.env.getFilter('escape').traceableCallable(60, this.source)(...[this.env, (((context.has(`href`))) ? (this.env.getFilter('default').traceableCallable(60, this.source)(...[(context.has(`href`) ? context.get(`href`) : null), `#`])) : (`#`)), `html`, null, true]));
                this.echo(`">
      `);
                this.echo(this.env.getFilter('escape').traceableCallable(61, this.source)(...[this.env, (context.has(`_content`) ? context.get(`_content`) : null), `html`, null, true]));
                this.echo(`
    </a>
    `);
                if ((context.has(`icon`) ? context.get(`icon`) : null)) {
                    this.echo(`      `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`class`, (context.has(`_icon_class`) ? context.get(`_icon_class`) : null)], [`name`, (context.has(`icon`) ? context.get(`icon`) : null)]]), false, false, 64));
                    this.echo(`    `);
                }
                this.echo(`  `);
            }

            getTemplateName() {
                return `47db05cf10de4356e3b2ef78415e3bec3029bc617aa2ade01eb5c25e57bb5961`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `47db05cf10de4356e3b2ef78415e3bec3029bc617aa2ade01eb5c25e57bb5961`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '47db05cf10de4356e3b2ef78415e3bec3029bc617aa2ade01eb5c25e57bb5961');

let template = env.loadTemplate('47db05cf10de4356e3b2ef78415e3bec3029bc617aa2ade01eb5c25e57bb5961');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/media-link/media-link.twig", args: context }
     );
     return rendered;;
};